// swap out crisalix logo for our version
(function replaceCrisalixLogo() {
  const replaceLogo = (logo) => {
    fetch('/wp-content/uploads/2026/01/logo-crisalix.svg')
      .then(res => res.text())
      .then(svg => {
        logo.outerHTML = svg;
      })
      .catch(err => console.error('Failed to load Crisalix logo:', err));
  };

  const existingLogo = document.querySelector('.crisalix-widget-logo img');
  if (existingLogo) {
    replaceLogo(existingLogo);
    return;
  }

  const observer = new MutationObserver((mutations, obs) => {
    const logo = document.querySelector('.crisalix-widget-logo img');
    if (logo) {
      replaceLogo(logo);
      obs.disconnect(); // stop observing
    }
  });

  // start observing when DOM is ready
  if (document.body) {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  } else {
    document.addEventListener('DOMContentLoaded', () => {
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    });
  }
})();
